import React, { useEffect, useState } from "react";
import { Card, CardBody, Col, Container, Row } from "reactstrap";
import ProfileDashboard from "./ProfileDashboard";
import { Line } from "react-chartjs-2";
import ReactApexChart from "react-apexcharts";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
} from "chart.js";
import TopCustomerModal from "./DashboardComponents/TopCustomerModal";
import TopSellingProductModal from "./DashboardComponents/TopSellingProductModal";
import CountUp from "react-countup";
import { topCustomers } from "../QRCodeCustomerPanel/Theme/DigitalMenuAI/Component/StaticData";
import { topProducts } from "../QRCodeCustomerPanel/Theme/DigitalMenuAI/Component/StaticData";
import OrganizationService from "../Services/QRCodeServices/OrganizationManagement/OrganizationService";
import PaymentDistributionChart from "./DashboardComponents/PaymentDistributionChart";

ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend
);

export default function Dashboard() {
  const [data, setData] = useState([]);
  const [dashboardData, setDashboardData] = useState([]);
  const [paymentData, setPaymentData] = useState([]);

  const user = JSON.parse(localStorage.getItem("user"));
  const orgId = user?.organizationInfo?.id || "";
  const role = user?.user?.roles[0] || "";
  // const hasOMS = user?.organizationInfo?.hasOMS || false;

  const [modalOpen, setModalOpen] = useState(false);
  const [sellingProductModalOpen, setSellingProductModalOpen] = useState(false);

  const toggleModal = () => {
    setModalOpen(!modalOpen);
  };
  const toggleSellingProductModal = () => {
    setSellingProductModalOpen(!sellingProductModalOpen);
  };

  const [stats, setStats] = useState({
    totalOrgs: 50,
    totalItems: 200,
    paidOrgs: 30,
    omsOrgs: 20,
  });

  const [newOrgSignUps, setNewOrgSignUps] = useState([
    5, 10, 15, 40, 20, 15, 10,
  ]);
  const [itemsAdded, setItemsAdded] = useState([2, 5, 8, 12, 18, 22, 30]);

  const [omsStats, setOmsStats] = useState({
    totalEarnings: 25000,
    totalKot: 212,
    totalBot: 300,
    bestSellingProduct: "Momo",
    topCustomer: "Sandip Lamicchane",
  });

  // Bar chart configuration
  const barChartOptions = {
    chart: {
      type: "bar",
      height: 350,
    },
    plotOptions: {
      bar: {
        horizontal: false,
        columnWidth: "55%",
        endingShape: "rounded",
      },
    },
    dataLabels: {
      enabled: false,
    },
    stroke: {
      show: true,
      width: 2,
      colors: ["transparent"],
    },
    title: {
      text: "Monthly Sales Overview",
      align: "left",
    },
    xaxis: {
      categories: ["Jan", "Feb", "Mar"],
    },
    yaxis: {
      title: {
        text: "$ (thousands)",
      },
    },
    fill: {
      opacity: 1,
    },
    tooltip: {
      y: {
        formatter: function (val) {
          return "$ " + val + " thousands";
        },
      },
    },
  };

  const barChartSeries = [
    {
      name: "Net Profit",
      data: [44, 55, 57],
    },
    {
      name: "Revenue",
      data: [76, 85, 101],
    },
  ];

  // Chart.js data
  const newOrgSignUpsData = {
    labels: ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"],
    datasets: [
      {
        label: "New Organizations",
        data: newOrgSignUps,
        borderColor: "#4CAF50",
        backgroundColor: "rgba(76, 175, 80, 0.2)",
        fill: true,
        tension: 0.4,
        pointRadius: 5,
        pointBackgroundColor: "#4CAF50",
        pointBorderColor: "#ffffff",
        pointBorderWidth: 2,
      },
    ],
  };

  const itemsAddedData = {
    labels: ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"],
    datasets: [
      {
        label: "Items Added",
        data: itemsAdded,
        borderColor: "#2196F3",
        backgroundColor: "rgba(33, 150, 243, 0.2)",
        fill: false,
        tension: 0.1,
        pointRadius: 5,
        pointBackgroundColor: "#2196F3",
        pointBorderColor: "#ffffff",
        pointBorderWidth: 2,
      },
    ],
  };

  // Non-OMS stats
  const [nonOmsStats, setNonOmsStats] = useState({
    totalCategories: 20,
    totalProducts: 200,
    totalVisitors: 333,
  });

  const fetchDetail = async () => {
    try {
      const response = await OrganizationService.detail(orgId);
      console.log("🚀 ~ fetchDetail ~ response:", response.hasOMS);
      setData(response);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    fetchDetail();
  }, []);

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <Row>
            <Row className="mt-3">
              {role !== "SuperAdmin" && (
                <Col lg={12}>
                  <p className="mb-2 fs-5 fw-semibold d-print-none">Profile</p>
                  <Card className="p-2 rounded-3 mb-2">
                    <ProfileDashboard data={data} />
                  </Card>
                </Col>
              )}

              {role === "SuperAdmin" && (
                <Col lg={12}>
                  <Row className="g-3 p-0 m-0">
                    <Col lg={3} md={6} sm={12}>
                      <Card className="p-3 text-center shadow-lg rounded-3 border-top border-success">
                        <h3 className="text-success">{stats.totalOrgs}</h3>
                        <p>Total Organizations</p>
                      </Card>
                    </Col>
                    <Col lg={3} md={6} sm={12}>
                      <Card className="p-3 text-center shadow-lg rounded-3 border-top border-primary">
                        <h3 className="text-primary">{stats.paidOrgs}</h3>
                        <p>Paid Organization</p>
                      </Card>
                    </Col>
                    <Col lg={3} md={6} sm={12}>
                      <Card className="p-3 text-center shadow-lg rounded-3 border-top border-warning">
                        <h3 className="text-warning">{stats.omsOrgs}</h3>
                        <p>Organizations with OMS</p>
                      </Card>
                    </Col>
                    <Col lg={3} md={6} sm={12}>
                      <Card className="p-3 text-center shadow-lg rounded-3 border-top border-danger">
                        <h3 className="text-danger">{stats.totalItems}</h3>
                        <p>Total Items</p>
                      </Card>
                    </Col>
                  </Row>

                  <Row>
                    <Col lg={6} md={12} className="mt-4">
                      <Card className="p-3 rounded-3 shadow-lg border-top border-success">
                        <p className="fs-5 fw-semibold text-center mb-3 text-success">
                          New Organization Sign-Ups
                        </p>
                        <Line
                          data={newOrgSignUpsData}
                          options={{ responsive: true }}
                        />
                      </Card>
                    </Col>

                    <Col lg={6} md={12} className="mt-4">
                      <Card className="p-3 rounded-3 shadow-lg border-top border-primary">
                        <p className="fs-5 fw-semibold text-center mb-3 text-primary">
                          Items Added to System
                        </p>
                        <Line
                          data={itemsAddedData}
                          options={{ responsive: true }}
                        />
                      </Card>
                    </Col>
                  </Row>
                </Col>
              )}

              {role !== "SuperAdmin" && data?.hasOMS && (
                <Col lg={12} className="mt-4">
                  <Row className="g-3 p-0 m-0">
                    <Col lg={4} md={6} sm={12}>
                      <Card className="card-animate cursor-pointer bg-info">
                        <CardBody>
                          <div className="d-flex align-items-center">
                            <div className="flex-grow1 overflow-hidden">
                              <p className="text-uppercase fw-bold text-white-50 text-truncate mb-0 text-decoration-underline">
                                Total Sales Count
                              </p>
                            </div>
                          </div>
                          <div className="d-flex align-items-end justify-content-between mt-4">
                            <div>
                              <h4 className="fs-22 fw-bold ff-secondary mb-4 text-white">
                                <span>
                                  <CountUp
                                    start={0}
                                    end={omsStats.totalEarnings}
                                    duration={2.5}
                                    separator=","
                                    prefix=""
                                  />
                                </span>
                              </h4>
                            </div>
                            <div className="avatar-sm flex-shrink-0">
                              <span
                                className={`avatar-title bg-white bg-opacity-10 rounded fs-3`}
                              >
                                <i
                                  className={`text-white bx bx-dollar-circle`}
                                ></i>
                              </span>
                            </div>
                          </div>
                        </CardBody>
                      </Card>
                    </Col>
                    <Col lg={4} md={6} sm={12}>
                      <Card className="card-animate cursor-pointer bg-secondary">
                        <CardBody>
                          <div className="d-flex align-items-center">
                            <div className="flex-grow1 overflow-hidden">
                              <p className="text-uppercase fw-bold text-white-50 text-truncate mb-0 text-decoration-underline">
                                Total KOT Count
                              </p>
                            </div>
                          </div>
                          <div className="d-flex align-items-end justify-content-between mt-4">
                            <div>
                              <h4 className="fs-22 fw-bold ff-secondary mb-4 text-white">
                                <span>
                                  <CountUp
                                    start={0}
                                    end={omsStats.totalKot}
                                    duration={2.5}
                                    separator=","
                                  />
                                </span>
                              </h4>
                            </div>
                            <div className="avatar-sm flex-shrink-0">
                              <span
                                className={`avatar-title bg-white bg-opacity-10 rounded fs-3`}
                              >
                                <i
                                  className={`text-white bx bx-shopping-bag`}
                                ></i>
                              </span>
                            </div>
                          </div>
                        </CardBody>
                      </Card>
                    </Col>
                    <Col lg={4} md={6} sm={12}>
                      <Card className="card-animate cursor-pointer bg-success">
                        <CardBody>
                          <div className="d-flex align-items-center">
                            <div className="flex-grow1 overflow-hidden">
                              <p className="text-uppercase fw-bold text-white-50 text-truncate mb-0 text-decoration-underline">
                                Total BOT Count
                              </p>
                            </div>
                          </div>
                          <div className="d-flex align-items-end justify-content-between mt-4">
                            <div>
                              <h4 className="fs-22 fw-bold ff-secondary mb-4 text-white">
                                <span>
                                  <CountUp
                                    start={0}
                                    end={omsStats.totalBot}
                                    duration={2.5}
                                    separator=","
                                  />
                                </span>
                              </h4>
                            </div>
                            <div className="avatar-sm flex-shrink-0">
                              <span
                                className={`avatar-title bg-white bg-opacity-10 rounded fs-3`}
                              >
                                <i
                                  className={`text-white bx bx-user-circle`}
                                ></i>
                              </span>
                            </div>
                          </div>
                        </CardBody>
                      </Card>
                    </Col>

                    <Col lg={4} md={6} sm={12}>
                      <Card className="p-3 text-center shadow-lg rounded-3 border-top border-info">
                        <h3 className="text-info">
                          {nonOmsStats.totalCategories}
                        </h3>
                        <p>Total Categories</p>
                      </Card>
                    </Col>
                    <Col lg={4} md={6} sm={12}>
                      <Card className="p-3 text-center shadow-lg rounded-3 border-top border-success">
                        <h3 className="text-success">
                          {nonOmsStats.totalProducts}
                        </h3>
                        <p>Total Products</p>
                      </Card>
                    </Col>
                    <Col lg={4} md={6} sm={12}>
                      <Card className="p-3 text-center shadow-lg rounded-3 border-top border-primary">
                        <h3 className="text-primary">
                          {nonOmsStats.totalVisitors.toLocaleString()}
                        </h3>
                        <p>Total Visitors</p>
                      </Card>
                    </Col>

                    <Col lg={6} md={6} sm={12}>
                      <Card
                        className="p-3 text-center shadow-lg rounded-3 border-top border-warning cursor-pointer"
                        onClick={toggleSellingProductModal}
                      >
                        <h3 className="text-warning">Best Selling Product</h3>
                      </Card>
                    </Col>
                    <Col lg={6} md={6} sm={12}>
                      <Card
                        className="p-3 text-center shadow-lg rounded-3 border-top border-danger cursor-pointer"
                        onClick={toggleModal}
                      >
                        <h3 className="text-danger">Top Customer</h3>
                      </Card>
                    </Col>
                  </Row>

                  <Row className="mt-4">
                    <Col lg={6} md={12}>
                      <Card className="p-3 rounded-3 shadow-lg">
                        <ReactApexChart
                          options={barChartOptions}
                          series={barChartSeries}
                          type="bar"
                          height={350}
                        />
                      </Card>
                    </Col>
                  </Row>
                </Col>
              )}
            </Row>
          </Row>
        </Container>
      </div>
      <TopCustomerModal
        isOpen={modalOpen}
        toggle={toggleModal}
        topCustomers={topCustomers}
      />
      <TopSellingProductModal
        isOpen={sellingProductModalOpen}
        toggle={toggleSellingProductModal}
        topProducts={topProducts}
      />
    </React.Fragment>
  );
}
